import { Directive, Input, inject, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[e2eSelector]',
})
export class E2ESelectorDirective {
  @Input() public e2eSelector: string | null;

  private elRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  public ngOnChanges() {
    if (this.e2eSelector) {
      this.renderer.setAttribute(this.elRef.nativeElement, 'data-cy', this.e2eSelector);
    }
  }

  public toString() {
    return this.e2eSelector;
  }
}
